import React from "react";
import { Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authActions } from "../redux/actions";
import { connect } from "react-redux";

const NologinRoute = (props) => {
	const { component: Component, isAuthenticated, ...rest } = props;
	const dispatch = useDispatch();

	if (isAuthenticated) {
		dispatch(authActions.logoutUser());
	}

	// RETURN
	return (
		<>
			<Route
				{...rest}
				render={(props) => <Component {...props} />
				}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	isAuthenticated: !!state.auth.authToken,
});

export default connect(mapStateToProps)(NologinRoute);
